/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Gesamtschule_Gedern2Inputs */

const en__field_enum_gesamtschule_gedern2 = /** @type {(inputs: _Field_Enum_Gesamtschule_Gedern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedern`)
};

const de__field_enum_gesamtschule_gedern2 = /** @type {(inputs: _Field_Enum_Gesamtschule_Gedern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtschule Gedern`)
};

/**
* | output |
* | --- |
* | "Gedern" |
*
* @param {_Field_Enum_Gesamtschule_Gedern2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_gesamtschule_gedern2 = /** @type {((inputs?: _Field_Enum_Gesamtschule_Gedern2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Gesamtschule_Gedern2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_gesamtschule_gedern2(inputs)
	return de__field_enum_gesamtschule_gedern2(inputs)
});
export { _field_enum_gesamtschule_gedern2 as "_field_enum_Gesamtschule_Gedern" }